module.exports = __webpack_public_path__ + "img/街道.43b707f8.png";